import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'

interface ConfirmDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	onConfirm: () => void | Promise<void>
	title: string
	description: string
	confirmText?: string
	cancelText?: string
	isDestructive?: boolean
}

export default function ConfirmDialog({
	open,
	onOpenChange,
	onConfirm,
	title,
	description,
	confirmText = 'ยืนยัน',
	cancelText = 'ยกเลิก',
	isDestructive = false,
}: ConfirmDialogProps) {
	const [loading, setLoading] = useState(false)

	const handleConfirm = async () => {
		setLoading(true)
		try {
			await onConfirm()
			onOpenChange(false)
		} finally {
			setLoading(false)
		}
	}

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{description}</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button
						variant="outline"
						onClick={() => onOpenChange(false)}
						disabled={loading}
					>
						{cancelText}
					</Button>
					<Button
						variant={isDestructive ? 'destructive' : 'default'}
						onClick={handleConfirm}
						disabled={loading}
					>
						{loading ? 'กำลังดำเนินการ...' : confirmText}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
